<template>
  <div class="message-actions-wrapper">
    <div class="message-action-tabs">
      <sms-action-tab
          :isTabOpen="isEmojiOpen"
          :tab="{icon:'smile', tabClass:'emoji-tab', tabType:'emoji', viewbox:'0 0 368 368'}"
          @toggleTab="toggleTabOpen">
      </sms-action-tab>
      <!--<sms-action-tab
          v-if="!isBackup"
          :hideTab="adImageUrl || mmsCounter || mediaLoading.mms"
          :isTabOpen="isAudioOpen"
          :mediaCounter="audioCounter"
          :tab="{icon:'phone', tabClass:'audio-tab', tabType:'audio', viewbox:'0 0 512.076 512.076'}"
          @toggleTab="toggleTabOpen">
      </sms-action-tab>-->
      <sms-action-tab
          :isTabOpen="isSwapOpen"
          :tab="{icon:'swap', tabClass:'swap-tab', tabType:'swap', viewbox:'0 0 384 384'}"
          @toggleTab="toggleTabOpen">
      </sms-action-tab>
    </div>
    <ad-image :messageModuleName="messageModuleName"></ad-image>
    <mms
        v-if="!isBackup"
        :isMmsOpen="isMmsOpen"
        :mediaError="errorMessage"
        :messageModuleName="messageModuleName"
        ref="mms"
        showClose
        @closeMms="toggleTabOpen"
        @getAttachedMedia="getAttachedMedia"
        @setMediaLoading="setMediaLoading"
        @updateCampaign="updateCampaign">
    </mms>
    <emojis
        :emojiOpen="isEmojiOpen"
        @closeEmoji="toggleTabOpen"
        @insertInTextArea="insertInTextArea">
    </emojis>
    <member-value
        :showMemberBalance="!!autoCampaignId"
        :showExpiration="autoCampaignType == 22"
        :isSwapOpen="isSwapOpen"
        @closeSwap="toggleTabOpen"
        @insertInTextArea="insertInTextArea">
    </member-value>
    <audio-attachment
        v-if="!isBackup"
        :activeMessage="activeMessage"
        :attachmentUrl="attachmentUrl"
        :isAudioOpen="isAudioOpen"
        :messageModuleName="messageModuleName"
        @closeAudio="toggleTabOpen"
        @getAttachedMedia="getAttachedMedia"
        @removeMediaAttachment="removeMediaAttachment"
        @setMediaLoading="setMediaLoading">
    </audio-attachment>
  </div>
</template>

<script>
  import AdImage from '../AdsList/AdImage'
  import AudioAttachment from '../MediaAttachments/AudioAttachment'
  import AxiosMixin from '../../mixins/AxiosMixin'
  import { mapState, mapGetters } from 'vuex'
  import Mms from '../MediaAttachments/Mms'
  import MemberValue from './InsertMemberValue'
  import Emojis from './Emojis'
  import SmsActionTab from './SmsActionTab'

  export default {
    props: {
      activeMessage: Boolean,
      messageModuleName: String,
    },

    name: 'SmsActions',

    components: {
      AdImage,
      AudioAttachment,
      Emojis,
      MemberValue,
      Mms,
      SmsActionTab
    },

    mixins: [AxiosMixin],

    data() {
      return {
        attachedMedia: null,
        attachmentUrl: null,
        errorMessage: null,
        isAudioAllowed: false,
        isAudioOpen: false,
        isEmojiOpen: false,
        isMmsOpen: false,
        isSwapOpen: false,
        mediaLoading: {
          audio: false,
          mms: false,
        },
      }
    },

    methods: {
      afterMediaDelete(data) {
        if (data && data.success) {
          this.setAttachmentErrors(null)
          this.getAttachedMedia()
        } else {
          this.setAttachmentErrors('could not delete media')
        }
      },

      configureAllAttachments(data) {
        const noGoodData = !data || typeof data === 'string',
          hasData = data && typeof data !== 'string'
        this.attachedMedia = hasData && data.length ? data[0] : null
        hasData && this.$store.dispatch(`${this.messageModuleName}/UPDATE_ATTACHED_MEDIA`, {attachedMedia: data})
        if (noGoodData) { this.loading = false }
        this.errorMessage = noGoodData ? 'no media found' : null
        this.$refs?.mms?.finishGettingAttachedMedia()
      },

      getAttachedMedia() {
        if (this.isBackup) { return }
        const params = { params: { label: ['mms', 'audio'] } }
        this.axiosMethod({url: this.attachmentUrl, params, onSuccess: this.configureAllAttachments, onError: this.setAttachmentErrors})
      },

      insertInTextArea(memberInput) {
        this.$emit('insertInTextArea', memberInput)
      },

      removeMediaAttachment(uuid) {
        if (uuid) {
          const url = `/api/v3/attachments/${uuid}`
          this.axiosMethod({methodType: 'delete', url, onSuccess: this.afterMediaDelete, onError: this.setAttachmentErrors})
        }
      },

      setAttachmentBaseUrl() {
        const type = this.autoCampaignId ? 'auto_campaign_messages': 'campaigns'
        let url = `/api/v3/${type}/${this.messageId}/campaign_attachments`
        this.attachmentUrl = this.autoCampaignId ? `${url}?auto_campaign_id=${this.autoCampaignId}` : url
      },

      setAttachmentErrors(errorMessage) {
        this.errorMessage = errorMessage ? `issue with the media: ${errorMessage}` : null
        this.$refs?.mms?.finishGettingAttachedMedia()
      },

      setMediaLoading(mediaType, isLoading) {
        this.$set(this.mediaLoading, mediaType, isLoading)
      },

      toggleTabOpen(tabType, isClose) {
        const capitalTabType = tabType.charAt(0).toUpperCase() + tabType.slice(1)
        this[`is${capitalTabType}Open`] = isClose ? false : !this[`is${capitalTabType}Open`]
      },

      updateCampaign(data) {
        this.$emit('updateCampaign', data)
      },
    },

    created() {
      this.setAttachmentBaseUrl()
      this.getAttachedMedia()
    },

    computed: {
      audioCounter: function () {
        return this.audioMedia?.length > 0 ? 1 : null
      },

      mmsCounter: function () {
        return this.mmsMedia?.length > 0 ? 1 : null
      },
      ...mapGetters(['classicCampaignsEnabled']),

      ...mapState({
        adImageUrl (state, getters) { return getters[`${this.messageModuleName}/adImageUrl`] },
        audioMedia (state, getters) { return getters[`${this.messageModuleName}/audios`] },
        autoCampaignId (state) { return state[this.messageModuleName]?.autoCampaignId },
        autoCampaignType (state) { return state[this.messageModuleName]?.autoCampaignType },
        isBackup (state) { return state[this.messageModuleName]?.isBackup },
        messageId (state) { return state[this.messageModuleName]?.messageId },
        mmsMedia (state, getters) { return getters[`${this.messageModuleName}/mms`] },
      })
    },

    watch: {
      attachedMedia: function () {
        if (this.attachedMedia?.label === 'audio') { this.isMmsOpen = false }
        if (this.attachedMedia?.label === 'mms') { this.isAudioOpen = false }
      },

      adImageUrl: function () {
        if (!!this.adImageUrl) {
          this.attachedMedia && this.removeMediaAttachment(this.attachedMedia.uuid)
          this.isMmsOpen = false
          this.isAudioOpen = false
        }
      },
    }
  }
</script>
